import { Geotab } from "@fairfleet/geotab";
import { TripRef } from "../../trip/TripRef";
import fetchTripsWithAnnotations from "./fetchTripsWithAnnotations";

/**
 * Removes every {@link TripAnnotation} of the given trips, leaving them without a
 * trip reason.
 *
 * @param geotab - The {@link Geotab} client.
 * @param trips - The trips to remove annotations from.
 */
export default async function removeAnnotationsForTrips(geotab: Geotab, trips: TripRef[]) {
  const tripsWithAnnotations = await fetchTripsWithAnnotations(geotab, trips);

  await Promise.all(
    tripsWithAnnotations.flatMap(trip =>
      trip.annotations.map(annotation => geotab.remove("TripAnnotation", { id: annotation.id })),
    ),
  );
}
